import { render } from "./SocialNetworks.vue?vue&type=template&id=5dc95623&scoped=true"
import script from "./SocialNetworks.vue?vue&type=script&lang=js"
export * from "./SocialNetworks.vue?vue&type=script&lang=js"

import "./SocialNetworks.vue?vue&type=style&index=0&id=5dc95623&scoped=true&lang=scss"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc95623"]])

export default __exports__